import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'app.components.SelectReportDimension.placeholder',
    defaultMessage: 'Select Dimension...',
    description: 'Default placeholder text for the select dimension component',
  },
  label: {
    id: 'app.components.SelectReportDimension.label',
    defaultMessage: 'Select Dimension',
    description: 'Label for the select dimension component',
  },
  clear: {
    id: 'app.components.SelectReportDimension.clear',
    defaultMessage: 'Clear all selected dimensions',
    description: 'Clear all selected dimensions',
  },
  ariaLabel: {
    id: 'app.components.SelectReportDimension.ariaLabel',
    defaultMessage: 'Select Dimension',
    description: 'Aria label for the select dimension component',
  },
  dimensionLabeltooltip: {
    id:
      'app.components.SelectReportDimension.MultiValueLabel.dimensionLabeltooltip',
    defaultMessage: 'All dimension values of this dimension are selected',
    description:
      'Tooltip for the multi value label of the select dimension component',
  },
})
